import { axios } from '../../../lib/axios';

export const getImage = async (key: string) => {
  key = encodeURIComponent(`image:${key}`);
  return await axios.get<string>(`/posts/${key}/image`);
};